import React from 'react';
import { InfoGhostIcon } from './Icons';
import Tooltip from './Tooltip';
import type { CustomTooltipProps } from './Tooltip';

const TooltipGhost: React.FC<CustomTooltipProps> = props => (
  <Tooltip {...props} containerClassName="ghost" button={<InfoGhostIcon />} />
);

export default TooltipGhost;
